// extracted by mini-css-extract-plugin
export default {"parent":"app-react-components-NavTabs-NavTabs-module__parent"};